import { Component, OnInit, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ReportingService } from '../reporting.service';

import { LoginService } from '../../login/login.service';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginSettings } from '../../login/LoginSetting.model';
import { AllReportsComponent } from '../all-reports/all-reports.component';

import { ReportFoldersComponent } from '../report-folders/report-folders.component';
import { AddReportFolderComponent } from '../report-folders/add-folder/add-folder.component';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportQueueComponent } from '../report-queue/report-queue.component';
import { ArchiveProcessComponent } from '../archive-report/archive-process.component';
import { AutomatedTestingSetupComponent } from '../automated-testing-setup/automated-testing-setup.component';


@AutoUnsubscribe()
@Component({
    selector: 'reportFooter',
    templateUrl: './report-footer.component.html',
    styleUrls: ['./report-footer.component.css']
})
export class ReportFooterComponent implements OnInit, AfterViewInit, OnDestroy {

    automatedTestingSetupDialogRef: MatDialogRef<AutomatedTestingSetupComponent>;

    loginSettings: LoginSettings;
    // ExpandCollapseButtonsComponent: ExpandCollapseButtonsComponent;
    // ReportFolders: ReportFolder[];
    // Reports: Report[];
    AllReportsDialogRef: MatDialogRef<AllReportsComponent>;
    ReportFoldersDialogRef: MatDialogRef<ReportFoldersComponent>;

    addReportFolderDialogRef: MatDialogRef<AddReportFolderComponent>; // for Add Entry in My Reports if no report folders exist



    @Input() hideFoldersButton: boolean;

    expandedRows: boolean[] = [];
    @Output() expandAllFolders: EventEmitter<boolean> = new EventEmitter();
    // @Output() isMyReports: EventEmitter<boolean> = new EventEmitter();
    @Output() refreshedReportFolders: EventEmitter<boolean> = new EventEmitter();

    archiveProcessDialogRef: MatDialogRef<ArchiveProcessComponent>;
    hideReportToArchiveButton: boolean;

    showAutomatedTestsButton = false;

    // @Input() private _IsMyReports: boolean;
    // @Input() private _IsAllReports: boolean;

    // get IsMyReports() {
    //     if (this.reportService.inDebugMode) {
    //         console.log('GET IsMyReports()');
    //         console.log(this._IsMyReports);
    //     }
    //     return this._IsMyReports;
    // }

    // @Input()
    // set IsMyReports(value) {
    //     if (this.reportService.inDebugMode) {
    //         console.log('SET IsMyReports(value)');
    //         console.log(value);
    //     }
    //     this._IsMyReports = value;
    // }


    // get IsAllReports() {
    //     if (this.reportService.inDebugMode) {
    //         console.log('GET IsAllReports()');
    //         console.log(this._IsAllReports);
    //     }
    //     return this._IsMyReports;
    // }

    // @Input()
    // set IsAllReports(value) {
    //     if (this.reportService.inDebugMode) {
    //         console.log('set IsAllReports(value)');
    //         console.log(value);
    //     }
    //     this._IsAllReports = value;
    // }

    private _showNoFoldersMessage: boolean;

    get showNoFoldersMessage(): boolean {
        // return this._showNoFoldersMessage;
        return this.reportService.showNoFoldersMessage;
    }

    // set showNoFoldersMessage(value: boolean) {
    //     //this._showNoFoldersMessage = value;
    //     this.reportService.showNoFoldersMessage = value;
    // }


    // public IsMyReports: boolean;
    // public IsAllReports: boolean;

    constructor(
        private dialogRef: MatDialogRef<ReportFooterComponent>,
        private reportService: ReportingService,
        private loginService: LoginService,
        private yearService: YearService,
        private dialog: MatDialog,

        private addReportFolderDialog: MatDialog,
        private archiveProcessDialog: MatDialog,

        private automatedTestingSetupDialog: MatDialog,

        // private allReportsDialogRef: MatDialogRef<AllReportsComponent>

        // public expandAll : ExpandCollapseButtonsComponent

    ) {
        this.loginSettings = loginService.LoginSettings;
        // this.userCanAutoRunReports = this.reportService.userCanAutoRunReports;


    } // end constructor

    ngOnInit() {

        if (this.reportService.reportingConfigurationSettings == null || this.reportService.reportingConfigurationSettings == undefined) {
            this.reportService.getReportingConfigurationSettings(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.AYIdentifier)
            .subscribe(settings => {
              this.reportService.reportingConfigurationSettings = settings;
              this.hideReportToArchiveButton = this.reportService.reportingConfigurationSettings.HideReportToArchiveButton;
            });
        }

        if (this.reportService.currentUser.UserName.toLowerCase() == 'tyleradmin' || this.reportService.currentUser.UserName.toLowerCase() == 'sdmadmin') {
            this.showAutomatedTestsButton = true;
        } else {
            this.showAutomatedTestsButton = false;
        }


        // this.userCanAutoRunReports = this.reportService.userCanAutoRunReports;
    }

    ngAfterViewInit() {
        // this.userCanAutoRunReports = this.reportService.userCanAutoRunReports;
    }

    ngOnDestroy() { }


    openAutomatedTestingSetup() {
        // confirm they want to archive the report
        this.automatedTestingSetupDialogRef = this.automatedTestingSetupDialog.open(AutomatedTestingSetupComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            minWidth: '85vw',
            maxWidth: '100vw',
            minHeight: '85vh',
            maxHeight: '100vh'
        });

        this.automatedTestingSetupDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log(result);
            }

            if (result == true) {



                //  this.reportService.getReportBatches();



                // this.dialogRef.close(true);
            }
        });
    }


    addMyReportsEntryClick() {
        // add report folder

        this.addReportFolderDialogRef = this.addReportFolderDialog.open(AddReportFolderComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.addReportFolderDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('addReportFolderDialogRef.afterClosed()');
                console.log(result);

            }

            if (result == true) {
                // we need to refresh report folders

                // this.reportService.getMyReportFolders();
                this.getMyReportFolders();
            }

        });

    }


    getMyReportFolders(): void {
        this.reportService.getMyReportFolders().subscribe(reportFolders => {
            // this.ReportFolders = reportFolders;
            this.reportService.ReportFolders = reportFolders;
            // this.reportService.reportFoldersChanged(true);

            // this.refreshedReportFolders.emit(true);

            // if (this.reportService.inDebugMode) {
            //     // console.log('MyReportsComponent =>  SelectFolders length: ' + this.reportService.ReportFolders.length);
            // }
        });
    }

    closeClick() {
        this.dialogRef.close();
        // console.log('ReportFooterComponent.ts => closeClick()');
        // this.allReportsDialogRef.close();
    }

    openReportFoldersWindow() {
        // console.log('ReportFooterComponent.ts => openAllReportsWindow()');

        this.ReportFoldersDialogRef = this.dialog.open(ReportFoldersComponent, {
            panelClass: 'tyl-mat-dialog', disableClose: true
            // disableClose = true
        });

        this.ReportFoldersDialogRef.afterClosed().subscribe(result => {

            // this.reportService.reportFoldersChanged(true);

            this.refreshedReportFolders.emit(result);

            if (this.reportService.inDebugMode) {
                console.log('ReportFoldersDialogRef.afterClosed()');
                console.log(result);
            }

        });


        // this.reportFolders

    }

    // openReportArchivesWindow() {

    // }

    openArchiveProcess() {
        // confirm they want to archive the report
        this.archiveProcessDialogRef = this.archiveProcessDialog.open(ArchiveProcessComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            minWidth: '85vw',
            maxWidth: '100vw',
            minHeight: '85vh',
            maxHeight: '100vh'
        });

        this.archiveProcessDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log(result);
            }

            if (result == true) {



                //  this.reportService.getReportBatches();



                // this.dialogRef.close(true);
            }
        });
    }



    // expandAll(expand) {

    // // //loop to get folder names and set to value of expand
    // for (let i = 0; i < this.ReportFolders.length; i++) {
    //     this.expandedRows[this.ReportFolders[i].Name] = expand;

    // }


    reportModeIsAllReports(): boolean {
        return this.reportService.isAllReports;
    }

    reportModeIsMyReports(): boolean {
        return this.reportService.isMyReports;
    }

    showMyReportsComponent() {
        this.reportService.isMyReports = true;
        this.reportService.isAllReports = false;
        // this.isMyReports.emit(true);
        // this.isAllReports.emit(false);
    }

    showAllReportsComponent() {
        this.reportService.isMyReports = false;
        this.reportService.isAllReports = true;
        // this.isAllReports.emit(true);
        // this.isMyReports.emit(false);
    }

    showReportFoldersDialog() {

    }


    expandAll(expand: boolean) {
        if (this.expandAllFolders != null) {
            this.expandAllFolders.emit(expand);
        }
    }




    openQueueList() {
        const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
          });
    }



    //     console.log('MyReportComponent.ts => expandAllClick( ' + expand + ')');
    //     console.log(this.ReportFolders);



    // }



} // end export class ReportFooterComponent
